import {
  DB_LIST_CLIENTS,
  DB_GET_CLIENT,
  DB_CLIENT_SURVEYS,
  DB_CLIENTS_ORG,
  DB_SEARCH_CLIENT,
  DB_AUTOCOMPLETE_CLIENT,
  CURR_CTAGS,
  UPDATE_SEARCH_CTAGS,
  DB_AUTOCOMPLETE_CTAG,
  GET_ALL_CTAGS,
  DB_CLIENT_SURVEYS_NOT_FILTER,
} from "constants/ActionTypes"

const INIT_STATE = {
  db_clients: [],
  db_client: null,
  db_client_surveys: null,
  db_client_surveys_not_filter: null,
  db_clients_by_project: null,
  db_clients_organisation: [],
  db_clients_search: [],
  db_clients_autocomplete: [],
  db_curr_ctags: [],
  db_input_ctags_search_results: [],
  db_ctags_autocomplete: [],
  db_all_ctags: [],
  db_survey_templates: {},
}

export default (state = INIT_STATE, action) => {
  switch(action.type) {

    case DB_LIST_CLIENTS: {
      return {
        ...state,
        db_clients: action.payload.clients
      }
    }

    case DB_GET_CLIENT: {
      return {
        ...state,
        db_client: action.payload.client
      }
    }

    case DB_CLIENT_SURVEYS: {
      return {
        ...state,
        db_client_surveys: action.payload.client_surveys,
        db_survey_templates: action.payload.client_templates,
      }
    }

    case DB_CLIENT_SURVEYS_NOT_FILTER: {
      return {
        ...state,
        db_client_surveys_not_filter: action.payload.client_surveys_not_filter,
      }
    }

    case DB_CLIENTS_ORG: {
      return {
        ...state,
        db_clients_organisation: action.payload.clients
      }
    }

    case DB_SEARCH_CLIENT: {
      return {
        ...state,
        db_clients_search: action.payload.clients
      }
    }

    case DB_AUTOCOMPLETE_CLIENT: {
      return {
        ...state,
        db_clients_autocomplete: action.payload.clients
      }
    }

    case CURR_CTAGS: {
      return {
        ...state,
        db_curr_ctags: action.payload.tags 
      }
    }

    case UPDATE_SEARCH_CTAGS: {
      return {
        ...state,
        db_input_ctags_search_results: action.payload.tags
      }
    }

    case DB_AUTOCOMPLETE_CTAG: {
      return{
        ...state,
        db_ctags_autocomplete: action.payload.tags,
      }
    }

    case GET_ALL_CTAGS: {
      return {
        ...state,
        db_all_ctags: action.payload.tags
      }
    }

    default:
      return state;
  }
}